import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    TeaserUniversalTemplate,
    TeaserUniversalListTemplate,
    universalTeaserData,
} from "./teaser-universal.templates";

export default {
    title: "Website/Partial Templates/Teaser/Universal",
    render: TeaserUniversalTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {
    args: {
        ...universalTeaserData,
    },
    argTypes: {
        media: {
            options: ["image", "video", "icon", "none"],
            control: { type: "radio" },
        },
        button: {
            control: "boolean",
        },
        buttonType: {
            options: ["default", "primary"],
            control: { type: "radio" },
        },
        textAlignment: {
            options: ["left", "center", "right"],
            control: { type: "radio" },
        },
        highlight: {
            control: "boolean",
        },
    },
};

export const List = {
    render: TeaserUniversalListTemplate.bind({}),
    args: {
        tilesPerRow: 3,
    },
    argTypes: {
        tilesPerRow: {
            control: {
                type: "range",
                min: 1,
                max: 3,
                step: 1,
            },
        },
    },
};
